"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var RemainingChars_1 = require("components/RemainingChars");
var styles = __importStar(require("./TextArea.module.css"));
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        return _super.call(this, props) || this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, _b = _a.errors, errors = _b === void 0 ? {} : _b, rows = _a.rows, className = _a.className, maxLength = _a.maxLength;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root + " " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", { className: styles.description }, " Comment: "),
            react_1.default.createElement("textarea", { id: id, rows: rows, className: css, value: value, maxLength: maxLength, onChange: function (event) {
                    event.preventDefault();
                    onChange(id, event.target.value);
                } }),
            maxLength && !window.isPdf && (react_1.default.createElement(RemainingChars_1.RemainingChars, { maxLength: maxLength, value: value })),
            error && react_1.default.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1RleHRBcmVhL1RleHRBcmVhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLDREQUF3RDtBQUN4RCw0REFBK0M7QUFZL0M7SUFBOEIsNEJBQTRCO0lBQ3RELGtCQUFZLEtBQUs7ZUFDYixrQkFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztJQUNNLHlCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQStFLEVBQTlFLHdCQUFTLEVBQUUsVUFBRSxFQUFFLHNCQUFRLEVBQUUsY0FBVyxFQUFYLGdDQUFXLEVBQUUsY0FBSSxFQUFFLHdCQUFTLEVBQUUsd0JBQXVCLENBQUE7UUFDckYsSUFBSSxLQUFLLEdBQUcsU0FBUyxDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUMvQixJQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUE7UUFFeEIsSUFBSSxHQUFHLEdBQU0sTUFBTSxDQUFDLElBQUksU0FBSSxTQUFXLENBQUE7UUFDdkMsSUFBSSxLQUFLLEVBQUU7WUFDUCxHQUFHLEdBQU0sR0FBRyxTQUFJLE1BQU0sQ0FBQyxTQUFXLENBQUE7U0FDckM7UUFFRCxPQUFPLENBQ0g7WUFDSSx5Q0FBTyxTQUFTLEVBQUUsTUFBTSxDQUFDLFdBQVcsaUJBQW9CO1lBQ3hELDRDQUNJLEVBQUUsRUFBRSxFQUFFLEVBQ04sSUFBSSxFQUFFLElBQUksRUFDVixTQUFTLEVBQUUsR0FBRyxFQUNkLEtBQUssRUFBRSxLQUFLLEVBQ1osU0FBUyxFQUFFLFNBQVMsRUFDcEIsUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixLQUFLLENBQUMsY0FBYyxFQUFFLENBQUE7b0JBQ3RCLFFBQVEsQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQTtnQkFDcEMsQ0FBQyxHQUFhO1lBQ2pCLFNBQVMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLElBQUksQ0FDM0IsOEJBQUMsK0JBQWMsSUFBQyxTQUFTLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxLQUFlLEdBQUksQ0FDbkU7WUFDQSxLQUFLLElBQUkscUNBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU0sQ0FDaEQsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLGVBQUM7QUFBRCxDQUFDLEFBbENELENBQThCLGlCQUFTLEdBa0N0QztBQWxDWSw0QkFBUSJ9